import { render, staticRenderFns } from "./vs_csm_ai_gen_draft.vue?vue&type=template&id=aaf35e60&scoped=true"
import script from "./vs_csm_ai_gen_draft.vue?vue&type=script&lang=js"
export * from "./vs_csm_ai_gen_draft.vue?vue&type=script&lang=js"
import style0 from "./vs_csm_ai_gen_draft.vue?vue&type=style&index=0&id=aaf35e60&prod&scoped=true&lang=css"
import style1 from "./vs_csm_ai_gen_draft.vue?vue&type=style&index=1&id=aaf35e60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf35e60",
  null
  
)

export default component.exports